import { render, staticRenderFns } from "./paginationVue.vue?vue&type=template&id=3a47708e"
import script from "./paginationVue.vue?vue&type=script&lang=js"
export * from "./paginationVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports